<template>
  <header class="site-header">
    <div class="site-header-row">
      <router-link to="/" class="brand-slant" :title="$t('nav.home')" exact>
        <span class="brand-inner">
          <img src="@/assets/logo1.png" alt="" class="brand-icon">
          <div v-if="$i18n.locale === 'zh-CN'" class="brand-text brand-text--stack">
            <span class="brand-line-primary">{{ $t('brand.linePrimaryZh') }}</span>
            <span class="brand-line-secondary">{{ $t('brand.lineSecondaryEn') }}</span>
          </div>
          <span v-else-if="$i18n.locale === 'ja'" class="brand-text brand-text--stack">
            <span class="brand-line-primary">{{  $t('brand.singleLine')  }}</span>
            <span class="brand-line-jp">{{ $t('brand.lineSecondaryEn') }}</span>
            </span>
          <span v-else class="brand-text brand-text--single" style='font-size: 20px;'>
            {{ $t('brand.singleLine') }}
          </span>
        </span>
      </router-link>

      <nav class="nav" aria-label="Main">
      
      </nav>

      <div class="lang-block" role="group" :aria-label="$t('lang.en')">
        <img :src="require('@/assets/earth.png')" alt="" class="globe-icon">
        <button
          type="button"
          class="lang-link"
          :class="{ 'is-lang-active': $i18n.locale === 'zh-CN' }"
          @click="setLang('zh-CN')"
        >
          {{ $t('lang.zh') }}
        </button>
        <span class="lang-pipe">|</span>
        <button
          type="button"
          class="lang-link"
          :class="{ 'is-lang-active': $i18n.locale === 'ja' }"
          @click="setLang('ja')"
        >
          {{ $t('lang.ja') }}
        </button>
        <span class="lang-pipe">|</span>
        <button
          type="button"
          class="lang-link"
          :class="{ 'is-lang-active': $i18n.locale === 'en' }"
          @click="setLang('en')"
        >
          {{ $t('lang.en') }}
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { setI18nLocale } from '@/i18n'

export default {
  name: 'SiteHeader',
  computed: {
    isProductCenterActive() {
      const p = this.$route.path
      return p === '/product-center' || p.startsWith('/detail') || this.$route.name === 'detail'
    },
  },
  methods: {
    setLang(code) {
      if (code === this.$i18n.locale) return
      setI18nLocale(code)
      const clean = `${window.location.pathname}${window.location.search}`
      if (window.location.hash) {
        window.location.replace(clean)
      } else {
        window.location.reload()
      }
    },
  },
}
</script>

<style scoped>
.site-header {
  --nav-blue: #2563eb;
  --nav-bg: #141518;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2000;
  min-height: 88px;
  background: var(--nav-bg);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.06);
}

.site-header-row {
  display: flex;
  align-items: stretch;
  min-height: 88px;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
}

.brand-slant {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding: 0 90px 0 25px;
  background: var(--nav-blue);
  color: #fff;
  text-decoration: none;
  clip-path: polygon(0 0, calc(100% - 66px) 0, 100% 100%, 0 100%);
}

.brand-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.brand-icon {
  width: 56px;
  height: 33px;
  flex-shrink: 0;
}

.brand-text {
  color: #fff;
  min-width: 0;
}

.brand-text--stack {
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: 1.25;
  text-align: left;
}

.brand-line-primary {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 1px;
  white-space: nowrap;
}

.brand-line-secondary {
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.02em;
  opacity: 0.95;
  white-space: nowrap;
  max-width: 52vw;
  overflow: hidden;
  text-overflow: ellipsis;
}
.brand-line-jp{
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.02em;
  opacity: 0.95;
  white-space: nowrap;
  max-width: 52vw;
  overflow: hidden;
  text-overflow: ellipsis;
}
.brand-text--single {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.04em;
  line-height: 1.3;
  max-width: min(520px, 42vw);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.nav {
  flex: 1;
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 0;
}

.nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 50px;
  font-size: 22px;
  font-weight: 400;
  letter-spacing: 0.03em;
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;
}

.nav-item:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.06);
}

.nav-item.is-active {
  background: var(--nav-blue);
  color: #fff;
}

.nav-item.is-active:hover {
  background: var(--nav-blue);
}

.lang-block {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 48px 0 16px;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.95);
}

.globe-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  opacity: 0.95;
}

.lang-link {
  margin: 0;
  padding: 0 2px;
  border: none;
  background: none;
  cursor: pointer;
  font: inherit;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0.04em;
  color: #fff;
  opacity: 0.82;
  transition: opacity 0.15s ease, color 0.15s ease;
  white-space: nowrap;
}

.lang-link.is-lang-active {
  opacity: 1;
  font-weight: 500;
  color: #0f62ea;
}

.lang-pipe {
  color: #ffffff;
  font-size: 14px;
  user-select: none;
  opacity: 0.6;
}

@media (max-width: 960px) {
  .brand-line-primary {
    font-size: 12px;
  }

  .brand-line-secondary {
    font-size: 10px;
    max-width: 36vw;
  }
  .brand-line-jp{
    font-size: 10px;
    max-width: 36vw;
  }
  .brand-text--single {
    font-size: 11px;
    max-width: 32vw;
  }

  .brand-slant {
    padding: 0 28px 0 14px;
  }

  .nav-item {
    padding: 0 16px;
    font-size: 14px;
  }

  .lang-link {
    font-size: 12px;
  }
}

@media (max-width: 520px) {
  .brand-text--stack .brand-line-secondary, .brand-text--stack .brand-line-jp {
    display: none;
  }

  .brand-text--single {
    display: none;
  }

  .brand-slant {
    padding: 0 20px 0 12px;
  }

  .nav-item {
    padding: 0 12px;
    font-size: 13px;
  }

  .lang-block {
    padding: 0 12px 0 8px;
    gap: 4px;
  }

  .globe-icon {
    width: 18px;
    height: 18px;
  }

  .lang-link {
    font-size: 11px;
  }
}
</style>
